import { render, staticRenderFns } from "./CommissionHistoryTab.vue?vue&type=template&id=4226199c"
import script from "./CommissionHistoryTab.vue?vue&type=script&lang=js"
export * from "./CommissionHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports